import { Card } from 'primereact/card';

export const TypographyUtilitiesSection = () => {
  return (
    <div id='typography-utilities' className='space-y-6'>
      <div>
        <h2 className='text-2xl font-bold mb-2'>Typography & Utilities</h2>
        <p className='text-gray-600 mb-4'>
          Typography styles and utility classes for text formatting.
        </p>
      </div>

      {/* Heading Styles */}
      <Card title='Heading Styles' className='mb-4'>
        <div className='space-y-4'>
          <div className='border-b pb-3'>
            <h1 className='text-4xl font-bold'>
              Heading 1 - text-4xl font-bold
            </h1>
          </div>
          <div className='border-b pb-3'>
            <h2 className='text-3xl font-bold'>
              Heading 2 - text-3xl font-bold
            </h2>
          </div>
          <div className='border-b pb-3'>
            <h3 className='text-2xl font-bold'>
              Heading 3 - text-2xl font-bold
            </h3>
          </div>
          <div className='border-b pb-3'>
            <h4 className='text-xl font-semibold'>
              Heading 4 - text-xl font-semibold
            </h4>
          </div>
          <div className='border-b pb-3'>
            <h5 className='text-lg font-semibold'>
              Heading 5 - text-lg font-semibold
            </h5>
          </div>
          <div>
            <h6 className='text-base font-semibold'>
              Heading 6 - text-base font-semibold
            </h6>
          </div>
        </div>
      </Card>

      {/* Text Sizes */}
      <Card title='Text Sizes' className='mb-4'>
        <div className='space-y-3'>
          <p className='text-xs'>Extra Small Text - text-xs (12px)</p>
          <p className='text-sm'>Small Text - text-sm (14px)</p>
          <p className='text-base'>Base Text - text-base (16px)</p>
          <p className='text-lg'>Large Text - text-lg (18px)</p>
          <p className='text-xl'>Extra Large Text - text-xl (20px)</p>
          <p className='text-2xl'>2XL Text - text-2xl (24px)</p>
        </div>
      </Card>

      {/* Font Weights */}
      <Card title='Font Weights' className='mb-4'>
        <div className='space-y-3'>
          <p className='font-light'>Light - font-light (300)</p>
          <p className='font-normal'>Normal - font-normal (400)</p>
          <p className='font-medium'>Medium - font-medium (500)</p>
          <p className='font-semibold'>Semibold - font-semibold (600)</p>
          <p className='font-bold'>Bold - font-bold (700)</p>
        </div>
      </Card>

      {/* Text Colors */}
      <Card title='Text Colors' className='mb-4'>
        <div className='space-y-4'>
          <div>
            <h3 className='text-sm font-semibold mb-3 text-gray-700'>
              Gray Scale
            </h3>
            <div className='space-y-2'>
              <p className='text-gray-900'>
                Gray 900 - Primary Text - text-gray-900
              </p>
              <p className='text-gray-800'>
                Gray 800 - Secondary Text - text-gray-800
              </p>
              <p className='text-gray-700'>Gray 700 - Labels - text-gray-700</p>
              <p className='text-gray-600'>
                Gray 600 - Body Text - text-gray-600
              </p>
              <p className='text-gray-500'>
                Gray 500 - Muted Text - text-gray-500
              </p>
              <p className='text-gray-400'>
                Gray 400 - Disabled Text - text-gray-400
              </p>
            </div>
          </div>

          <div>
            <h3 className='text-sm font-semibold mb-3 text-gray-700'>
              Semantic Colors
            </h3>
            <div className='space-y-2'>
              <p className='text-blue-600'>
                Blue 600 - Primary/Info - text-blue-600
              </p>
              <p className='text-green-600'>
                Green 600 - Success - text-green-600
              </p>
              <p className='text-red-600'>
                Red 600 - Danger/Error - text-red-600
              </p>
              <p className='text-amber-600'>
                Amber 600 - Warning - text-amber-600
              </p>
              <p className='text-purple-600'>
                Purple 600 - Accent - text-purple-600
              </p>
            </div>
          </div>
        </div>
      </Card>

      {/* Text Alignment */}
      <Card title='Text Alignment' className='mb-4'>
        <div className='space-y-4'>
          <div className='bg-gray-50 p-3 rounded'>
            <p className='text-left'>Left Aligned - text-left</p>
          </div>
          <div className='bg-gray-50 p-3 rounded'>
            <p className='text-center'>Center Aligned - text-center</p>
          </div>
          <div className='bg-gray-50 p-3 rounded'>
            <p className='text-right'>Right Aligned - text-right</p>
          </div>
          <div className='bg-gray-50 p-3 rounded'>
            <p className='text-justify'>
              Justified Text - text-justify. This is a longer paragraph to
              demonstrate text justification. The text will be distributed
              evenly across the full width of the container, creating straight
              edges on both sides.
            </p>
          </div>
        </div>
      </Card>

      {/* Text Styles */}
      <Card title='Text Styles & Decorations' className='mb-4'>
        <div className='space-y-3'>
          <p className='italic'>Italic Text - italic</p>
          <p className='underline'>Underlined Text - underline</p>
          <p className='line-through'>Strikethrough Text - line-through</p>
          <p className='uppercase'>Uppercase text - uppercase</p>
          <p className='lowercase'>LOWERCASE TEXT - lowercase</p>
          <p className='capitalize'>capitalized text - capitalize</p>
        </div>
      </Card>

      {/* Common Text Patterns */}
      <Card title='Common Text Patterns' className='mb-4'>
        <div className='space-y-6'>
          <div>
            <h3 className='text-sm font-semibold mb-2 text-gray-700'>
              Page Title
            </h3>
            <div className='bg-gray-50 p-4 rounded'>
              <h1 className='text-2xl font-bold text-gray-900'>Page Title</h1>
              <p className='text-sm text-gray-500 mt-1'>
                Supporting subtitle or description
              </p>
            </div>
          </div>

          <div>
            <h3 className='text-sm font-semibold mb-2 text-gray-700'>
              Section Header
            </h3>
            <div className='bg-gray-50 p-4 rounded'>
              <h2 className='text-xl font-semibold text-gray-900'>
                Section Header
              </h2>
            </div>
          </div>

          <div>
            <h3 className='text-sm font-semibold mb-2 text-gray-700'>
              Form Label
            </h3>
            <div className='bg-gray-50 p-4 rounded'>
              <label
                htmlFor='example-field'
                className='block text-sm font-medium text-gray-700 mb-2'
              >
                Field Label <span className='text-red-500'>*</span>
              </label>
              <p className='text-xs text-gray-500'>
                Helper text or description
              </p>
            </div>
          </div>

          <div>
            <h3 className='text-sm font-semibold mb-2 text-gray-700'>
              Body Text
            </h3>
            <div className='bg-gray-50 p-4 rounded'>
              <p className='text-base text-gray-900 mb-2'>
                Primary body text uses text-base with text-gray-900 for optimal
                readability.
              </p>
              <p className='text-sm text-gray-600'>
                Secondary body text uses text-sm with text-gray-600 for less
                prominent information.
              </p>
            </div>
          </div>

          <div>
            <h3 className='text-sm font-semibold mb-2 text-gray-700'>
              Muted/Helper Text
            </h3>
            <div className='bg-gray-50 p-4 rounded'>
              <p className='text-sm text-gray-500'>
                Muted text uses text-sm with text-gray-500 for helper text,
                timestamps, and supplementary information.
              </p>
            </div>
          </div>

          <div>
            <h3 className='text-sm font-semibold mb-2 text-gray-700'>
              Link Text
            </h3>
            <div className='bg-gray-50 p-4 rounded'>
              <a
                href='https://example.com'
                className='text-blue-600 hover:text-blue-800 underline'
              >
                Standard Link
              </a>
              <span className='mx-3'>|</span>
              <a
                href='https://example.com'
                className='text-blue-600 hover:text-blue-800 hover:underline'
              >
                Link with Hover Underline
              </a>
            </div>
          </div>
        </div>
      </Card>

      {/* Utility Classes */}
      <Card title='Common Utility Classes' className='mb-4'>
        <div className='space-y-4'>
          <div>
            <h3 className='text-sm font-semibold mb-2 text-gray-700'>
              Truncate Text
            </h3>
            <div className='bg-gray-50 p-4 rounded'>
              <p className='truncate w-64'>
                This is a very long text that will be truncated with an ellipsis
                when it exceeds the container width
              </p>
            </div>
          </div>

          <div>
            <h3 className='text-sm font-semibold mb-2 text-gray-700'>
              Line Clamp
            </h3>
            <div className='bg-gray-50 p-4 rounded'>
              <p className='line-clamp-2'>
                This is a longer paragraph that will be clamped to 2 lines. When
                the text exceeds two lines, it will be truncated with an
                ellipsis. This is useful for card descriptions and preview text
                where you want to limit the vertical space.
              </p>
            </div>
          </div>

          <div>
            <h3 className='text-sm font-semibold mb-2 text-gray-700'>
              Line Height
            </h3>
            <div className='space-y-3'>
              <div className='bg-gray-50 p-3 rounded'>
                <p className='leading-tight'>
                  Tight line height - leading-tight
                </p>
                <p className='leading-tight'>Second line of tight text</p>
              </div>
              <div className='bg-gray-50 p-3 rounded'>
                <p className='leading-normal'>
                  Normal line height - leading-normal
                </p>
                <p className='leading-normal'>Second line of normal text</p>
              </div>
              <div className='bg-gray-50 p-3 rounded'>
                <p className='leading-relaxed'>
                  Relaxed line height - leading-relaxed
                </p>
                <p className='leading-relaxed'>Second line of relaxed text</p>
              </div>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};
